export enum ValidatorName {
  Min = 'min',
  Max = 'max',
  MaxLength = 'maxlength',
  MinLength = 'minlength',
  Required = 'required',
  Email = 'email',
}
